export const dm3Config = {
    version: '1.4.1',
};
